// extracted by mini-css-extract-plugin
export default {"componentWrapper":"ThankYouRegister_componentWrapper__knbCT","actions":"ThankYouRegister_actions__C0nzr"};